import React, { useContext, useState, useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import { GlobalContext } from '../context/GlobalState'

const Profile = () => {
  const context = useContext(GlobalContext)
  const { user, updateUser } = context

  useEffect(() => {
    setUpdatedUser(user)
  //eslint-disable-next-line
  }, [])

  /* local state for login form */
  const [ updatedUser, setUpdatedUser ] = useState({
    fname: '',
    lname: '',
    email: '',
    username: '',
    password: '',
    bio: '',
    avatar: ''
  })

  /* onchange for form fields */
  const onChange = e => {
    setUpdatedUser({...updatedUser, [e.target.name]: e.target.value })
  }

  /* update avatar in user object */
  const updateAvatar = avt => {
    setUpdatedUser({...updatedUser, avatar: avt })
  }

  /* attempt to update user details */
  const onSubmit = async e => {
    e.preventDefault()
    updateUser(updatedUser)
  }

  return (
    <div className="all-pages-bg">
      <Header style={'mini'} />
      <div className="list-content">
        <div className="list-info">
          <h5>Profile</h5>
          <p>Update your profile settings here</p>
        </div>
        <div className="share-add">
          <form onSubmit={onSubmit}>
            <input 
              type="text" 
              placeholder="First name"
              name="fname" 
              value={updatedUser.fname}
              onChange={onChange}>
            </input>
            <input 
              type="text" 
              placeholder="Last name"
              name="lname" 
              value={updatedUser.lname}
              onChange={onChange}>
            </input>
            <input 
              type="email" 
              placeholder="Email"
              name="email" 
              value={updatedUser.email}
              onChange={onChange}>
            </input>
            <input 
              type="text" 
              placeholder="Username"
              name="username" 
              value={updatedUser.username}
              onChange={onChange}>
            </input>
            <input
              type="password"
              placeholder="Password"
              name="password"
              value={updatedUser.password}
              onChange={onChange}>
            </input>
            <input
              type="text"
              placeholder="Bio"
              name="bio"
              value={updatedUser.bio}
              onChange={onChange}>
            </input>
            <p className='p-center'>Select avatar...</p>
            <div className='avatar-container'>
              <i className={updatedUser.avatar === '' ? 'fas fa-user avatar-selected' : 'fas fa-user'}
                 onClick={() => updateAvatar('')}>
              </i>
              <i className={updatedUser.avatar === '-md' ? 'fas fa-user-md avatar-selected' : 'fas fa-user-md'}
                onClick={() => updateAvatar('-md')}>
              </i>
              <i className={updatedUser.avatar === '-astronaut' ? 'fas fa-user-astronaut avatar-selected' : 'fas fa-user-astronaut'}
                onClick={() => updateAvatar('-astronaut')}>
              </i>
              <i className={updatedUser.avatar === '-graduate' ? 'fas fa-user-graduate avatar-selected' : 'fas fa-user-graduate'}
                onClick={() => updateAvatar('-graduate')}>
              </i>
              <i className={updatedUser.avatar === '-ninja' ? 'fas fa-user-ninja avatar-selected' : 'fas fa-user-ninja'}
                onClick={() => updateAvatar('-ninja')}>
              </i>
              <i className={updatedUser.avatar === '-nurse' ? 'fas fa-user-nurse avatar-selected' : 'fas fa-user-nurse'}
                onClick={() => updateAvatar('-nurse')}>
              </i>
              <i className={updatedUser.avatar === '-secret' ? 'fas fa-user-secret avatar-selected' : 'fas fa-user-secret'}
                onClick={() => updateAvatar('-secret')}>
              </i>
              <i className={updatedUser.avatar === '-tie' ? 'fas fa-user-tie avatar-selected' : 'fas fa-user-tie'}
                onClick={() => updateAvatar('-tie')}>
              </i>
            </div>
            <input type="submit" className="share_bttn" value="Update"></input>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Profile